import { Link, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, ShoppingCart, Package, User } from 'lucide-react';
import { useCart } from '@/contexts/CartContext';
import { useAuth } from '@/hooks/use-auth';
import { cn } from '@/lib/utils';

const tabs = [
  { path: '/', icon: Home, label: 'Нүүр' },
  { path: '/shop', icon: ShoppingBag, label: 'Дэлгүүр' },
  { path: '/cart', icon: ShoppingCart, label: 'Сагс' },
  { path: '/orders', icon: Package, label: 'Захиалга' },
  { path: '/profile', icon: User, label: 'Профайл' },
];

const MobileTabBar = () => {
  const location = useLocation();
  const { itemCount } = useCart();
  const { user } = useAuth();

  // Don't show tab bar on auth page
  if (location.pathname === '/auth') return null;

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border md:hidden">
      <div className="flex items-center justify-around h-16 px-2 safe-area-bottom">
        {tabs.map((tab) => {
          const active = isActive(tab.path);
          const Icon = tab.icon;
          const linkPath = !user && ['/cart', '/orders', '/profile'].includes(tab.path) ? '/auth' : tab.path;

          return (
            <Link
              key={tab.path}
              to={linkPath}
              className={cn(
                'flex flex-col items-center justify-center gap-0.5 flex-1 py-1 transition-colors relative',
                active ? 'text-primary' : 'text-muted-foreground'
              )}
            >
              <div className="relative">
                <Icon className="h-5 w-5" />
                {tab.path === '/cart' && itemCount > 0 && (
                  <span className="absolute -top-1.5 -right-2.5 bg-primary text-primary-foreground text-[10px] font-medium rounded-full min-w-[16px] h-4 flex items-center justify-center">
                    {itemCount}
                  </span>
                )}
              </div>
              <span className="text-[10px] font-medium">{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileTabBar;
